import { createFileRoute } from "@tanstack/react-router";
import { CompanyHubPage } from "../../pages/dashboard/company-hub/CompanyHub.page";

export const Route = createFileRoute("/_protected/dashboard/company-hub")({
  component: CompanyHubPage,
});
